import type { RequestSnapshotError } from './insights-data.js';

// Shared user-facing copy for request_channel_snapshot RPC errors. Kept in
// one place so the per-channel ChannelSnapshotCard on the channels sub-
// page and any aggregate refresh affordance stay aligned. Strings are
// deliberately plain and don't reference the AI layer (per project
// memory feedback_hide_ai_layer).

export function requestSnapshotErrorCopy(error: RequestSnapshotError): string {
  switch (error) {
    case 'cooldown_active':
      return 'Refreshed recently. Try again in a few minutes.';
    case 'channel_not_watched':
      return "This channel isn't set up for insights yet.";
    case 'not_a_member':
      return "You don't have access to this studio's insights.";
    case 'not_authenticated':
      return 'Your session has expired. Sign in to refresh.';
    case 'unknown':
    default:
      return "Couldn't refresh insights. Try again in a moment.";
  }
}
